import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Modal,
  AvatarGroup,
  Avatar,
  Button,
} from "@mui/material";
import LokIco from '../../common/assests/LokIcon.svg'
import Eyegreen from "../../common/assests/eyegreen.png";
import ReyleafLogo from "../../common/assests/reyleafLogo.svg";
import LockIconImg from "../../common/assests/lockicons.png";
import BlockIcon from "../../common/assests/blockIcon.png";
import DeleteIconImg from "../../common/assests/deleticon.png";
import TestingImg from "../../common/assests/gridimg3.png";
import ClockIcon from "../../common/assests/clock.svg";
import CrossIcon from "../../common/assests/croosicon.png";
import Adminimg from "../../common/assests/adminimg.png";
import location from "../../common/assests/location.svg";
import WatchLaterRoundedIcon from "@mui/icons-material/WatchLaterRounded";
import DelIcon from "../../common/assests/delIcon.svg";
import Locks from "../../common/assests/lockicon.svg";
import DeleteIcon from "@mui/icons-material/Delete";
import Paginations from "../../common/pagination/Paginations";
import { useSelector } from "react-redux";
import {
  blockVenderEventApi,
  deleteVenderEventApi,
  getAllEventsApi,
  resumeVenderEventApi,
  unpublishEventApi,
} from "../../api";
import Loader from "../../common/loader/Loader";
import { toast } from "react-toastify";
import "./EventManagement.css";
import configuration from "../../config/Config";

const EventManagement = () => {
  const token = useSelector((state) => state?.user?.user?.token);
  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventDetailsData, setEventDetailsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState(false);
  const [change, setChange] = useState(false);

  const handleClose = () => setOpen(false);

  const handleEventApi = async () => {
    try {
      setLoading(true);
      const response = await getAllEventsApi({ token, currentPage });
      // console.log("response event", response);
      setEventDetailsData(response?.events || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleEventApi();
  }, [currentPage, change]);

  const handleBlock = async (id) => {
    const confirmationMessage =
      "Are you sure, you want to Block this Events?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await blockVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  const handleResume = async (id) => {
    const confirmationMessage =
      "Are you sure, you want to publish this Events?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await resumeVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  const handleDelete = async (id) => {
    const confirmationMessage = "Are you sure, you want to Delete this Event?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await deleteVenderEventApi({ token, id });
      setChange(!change);
      toast.success(response.message);
      setOpen(false);
    } catch (error) {
      if (error?.status === 500) {
        toast.error("Some error occured");
      } else {
        toast.error(error?.error);
      }
      console.log("error", error);
    }
  };


  const handleUnPublish = async (id) => {
    const confirmationMessage =
      "Are you sure, you want to Unpublish this Events?";
    if (!window.confirm(confirmationMessage)) {
      return;
    }
    try {
      const response = await unpublishEventApi({ token, id });
      setChange(!change);
      toast.success(response?.message);
      setOpen(false);
    } catch (error) {
      {
        if (error?.status === 500) {
          toast.error("Some error occured");
        } else {
          toast.error(error?.error);
        }
        console.log("error", error);
      }
      console.log("error", error);
    }
  };

  const handleOpen = (event) => {
    setSelectedEvent(event);
    setOpen(true);
  };
  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };

  return (
    <div>
      {loading ? (
        <Loader variant="cardList" />
      ) : (
        <>
          <Box className="sidebarTab-eventManagement">
            <Typography className="sidebarTab-eventManagement-header">
              All Platform Events
            </Typography>
            <Box>
              {eventDetailsData?.length >0 ?(
                eventDetailsData.map((item) => (
                  <Box key={item?._id} className="sidebarTab-eventCard">
                    <Box className="sidebarTab-eventDetails">
                    <img
                    src={item?.picture 
                      ? `${configuration.cdnFront}/${item?.picture}` 
                      : ReyleafLogo} 
                        alt="Event"
                        className="sidebarTab-eventImage"
                      />
                      <Box>
                        <Box className="sidebarTab-eventHeader">
                          <Typography className="sidebarTab-eventContent">
                            {item?.title||"N/A"}
                          </Typography>
                          <img
                            src={ClockIcon}
                            alt="Clock"
                            className="sidebarTab-clockImage"
                          />
                          <Typography className="sidebarTab-eventDate">
                          {item?.eventDate
                            ? new Date(item?.eventDate).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "N/A"}
                          </Typography>
                        </Box>
                        <Typography className="sidebarTab-eventCategory">
                          {item?.category||"N/A"}
                        </Typography>
                        <Typography className="sidebarTab-eventDescription">
                          {item?.description||"N/A"}
                        </Typography>
                      </Box>
                    </Box>
                    <Box className="sidebarTab-actionIcons">
                      <IconButton onClick={() => handleOpen(item)}>
                        <img
                          src={Eyegreen}
                          alt="View"
                          className="sidebarTab-viewIcon"
                        />
                      </IconButton>
                      <IconButton 
                          onClick={() => 
                            item?.status === 'active' 
                              ? handleBlock(item?._id) 
                              : handleResume(item?._id)
                          }
                        >
                        <img src={item?.status=="active" ? LockIconImg : BlockIcon} alt="Lock" />
                      </IconButton>
                      <IconButton onClick={() => handleDelete(item?._id)}>
                        <img src={DeleteIconImg} alt="Delete" />
                      </IconButton>
                    </Box>
                  </Box>
                ))
              ):(
                <div style={{textAlign:'center'}}>
                No Data Found
                </div>
              )}
            
            </Box>
            <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
            />
          </Box>

          {/* Modal */}
          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: { xs: "80vw", sm: "80vw" },

                // maxWidth: "874px",
                maxWidth: "650px",

                // maxHeight:',
                bgcolor: "#FFF",
                borderRadius: "32px",
                boxShadow: 24,
                maxHeight: "80vh",
                p: 4,
                overflowY: "auto",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "@media (min-width: 1600px)": {
                  width: "90vw",
                },
                "@media (max-width: 1400px)": {
                  width: "80vw",
                },
                "@media (max-width: 1200px)": {
                  width: "70vw",
                },
                "@media (max-width: 1024px)": {
                  width: "60vw",
                },
                "@media (max-width: 767px)": {
                  width: "80vw",
                },
                "@media (max-width: 576px)": {
                  width: "90vw",
                },
                "@media (max-width: 480px)": {
                  width: "95vw",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: "20px", fontWeight: "700" }}>
                  Event Details
                </Typography>
                <IconButton onClick={handleClose}>
                  <img
                    src={CrossIcon}
                    alt="img"
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                </IconButton>
              </Box>

              {selectedEvent && (
                <>
                   <img
                    src={selectedEvent?.picture 
                      ? `${configuration.cdnFront}/${selectedEvent?.picture}` 
                      : ReyleafLogo} 
                    alt="Event"
                    style={{
                      width: "100%",
                      maxHeight: "263px",
                      borderRadius: "20px",
                      marginTop: "15px",
                    }}
                  />

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                      mt: 3,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#362B24",
                        fontFamily: "Heebo",
                      }}
                    >
                      {/*  Resource Title :  */}
                       {selectedEvent?.title||"N/A"}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <AvatarGroup

                        renderSurplus={(surplus) => (
                          <span>+{surplus.toString()[0]}k</span>
                        )}
                         total={selectedEvent?.members?.length || 0} 
                        sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                      >
                        {selectedEvent?.members?.slice(0, 3).map((member, index) => (
                        <Avatar
                          key={index}
                          alt={member?.name || "Anonymous"}
                          src={member?.avatar || Adminimg} 
                          sx={{ width: "25px", height: "25px" }}
                        />
                      ))}
                      </AvatarGroup>
                      <Typography
                        sx={{
                          fontWeight: "400",
                          color: "#362B24",
                          fontFamily: "Heebo",
                          fontSize: { xs: "10px", sm: "18px" },
                        }}
                      >
                          {selectedEvent?.joinedCount || "0"} Attendance
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 3,
                      marginTop: "20px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "28px",
                        background: "#362B24",
                        boxShadow: "1px 2px 30px 0px rgba(0, 0, 0, 0.06)",
                        width: "110px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        padding: "0 8px",
                        flexShrink: 0,
                        gap: 1,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <WatchLaterRoundedIcon
                        sx={{ color: "#FFF", width: "18px", height: "18px" }}
                      />
                      <Typography sx={{ color: "#FFF", fontSize: "10px" }}>
                      {selectedEvent?.eventDate
                            ? new Date(selectedEvent?.eventDate).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                }
                              )
                            : "N/A"}
                      </Typography>
                    </Box>

                    <Typography
                      sx={{
                        fontWeight: "400",
                        color: "#362B24",
                        fontSize: "13px",
                        fontFamily: "Heebo",
                      }}
                    >
                      {selectedEvent?.category||"N/A"}
                    </Typography>
                    <Typography>
                      <div className="d-flex gap-2">
                        <img src={location} />
                        <div
                          style={{
                            color: "#065F46",
                            fontSize: "13px",
                            fontWeight: "400",
                            fontFamily: "Heebo",
                          }}
                        >
                         {selectedEvent?.address||"N/A"}
                        </div>
                      </div>
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "17px",
                      fontWeight: "600",
                      color: "#362B24",
                      fontFamily: "Heebo",
                      mt: 3,
                    }}
                  >
                    Description
                  </Typography>
                  <Typography sx={{ mb: 2, opacity: 0.5, fontFamily: "Heebo" }}>
                    {selectedEvent?.description||"N/A"}
                  </Typography>

                  {/* btns */}
                  <div style={{ display: 'flex', gap: '8px' ,justifyContent:'center',flexWrap:'wrap',marginTop:'25px'}}>
                  <button 
                        onClick={() => 
                          selectedEvent?.status === "active" 
                            ? handleUnPublish(selectedEvent?._id) 
                            : handleResume(selectedEvent?._id)
                        }
                        style={{
                          borderRadius: '15px',
                          backgroundColor: selectedEvent?.status === "active" ?'#d7d5d3':"#362B24",
                          maxWidth: '190px',
                          width:'100%',
                          height: '50px',
                          flexShrink: 0,
                          
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color:selectedEvent?.status === "active"?'#362B24':"#FFF",
                          fontFamily:'Heebo',
                          textTransform:'none',
                          border:"none",
                          '&:hover': {
                            backgroundColor: '#d7d5d3', 
                          
                          }
                        
                        }}
                      
                      >
                        {selectedEvent?.status === "active" ? <img src={Locks} className="me-2"/>:<img src={LokIco} className="me-2"/>}
                        {selectedEvent?.status === "active" ? "Unpublish" : "Publish"}
                      </button>
                    <button
                    onClick={()=>handleDelete(selectedEvent?._id)}
                      style={{
                        borderRadius: '15px',
                        backgroundColor: '#EA001B',
                        maxWidth: '190px',
                        width:'100%',
                        height: '50px',
                        flexShrink: 0,
                        color: '#FFF', 
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontFamily:'Heebo',
                        border:"none",
                          textTransform:'none',
                          '&:hover': {
                            backgroundColor: '#EA001B', 
                            color: '#FFF', 
                          }
                      
                      }}
                      startIcon={<DeleteIcon />} 
                    >
                      <img src={DelIcon} className="me-2"/>
                      Delete
                    </button>
                  </div>
                </>
              )}
            </Box>
          </Modal>
        </>
      )}
    </div>
  );
};

export default EventManagement;
